module.exports = __webpack_public_path__ + "static/media/r_itdot_12.9dc1f9ce.png";